


























import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { examCreateModule } from '@/store/modules/frames/exam-create.module';
import { GPageBase } from '@/mixins';
import { GEnum } from '@/constants/enum.defination';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { SchoolClass } from '@/models/school-class/school-class';
import GExamCreateExamineeStudentTable from '@/views/GExamCreate/ExamineeSetting/GExamCreateExamineeStudentTable.vue';
import { Student } from '@/models/student/student';

@Component({
  name: 'GExamCreateExamineeSettingStudents',
  components: { GExamCreateExamineeStudentTable },
  computed: {},
  methods: {},
})
export default class GExamCreateExamineeSettingStudents extends Mixins(GPageBase) {
  grade: number = 0;
  schoolClassID: number = 0;
  fileExcelName: string = '';
  excelFile: File = undefined;

  async mounted() {
    if (this.grades.length > 0) {
      this.grade = this.grades[0];
    }
    this.schoolClassID = this.refreshSchoolClassModel(this.schoolClasses, this.grade);
  }

  handleSelectFile(fileExcel: File): void {
    this.fileExcelName = fileExcel.name;
    this.excelFile = fileExcel;
    this.handleExcelUpload();
  }

  get grades(): number[] {
    return schoolClassModule.grades;
  }

  get schoolClasses(): SchoolClass[] {
    return schoolClassModule.schoolClasses;
  }

  handleExcelUpload(): boolean {
    if (!this.excelFile) {
      this.showNotice(GEnum.MessageType.Warn, 'Empty Error!', 'Please choose and Excel file with .xl or .xlxs extension.', 3);
      return false;
    }
    let requiredFormat: any = ['xls', 'xlsx'];
    let fileExt = this.excelFile.name.split('.').pop();
    if (!requiredFormat.includes(fileExt)) {
      this.showNotice(GEnum.MessageType.Warn, this.$t('MESSAGE_SET_EXCEL_FILE').toString(), '', 3);
      return false;
    }
    this.isRunning = true;
    let formData = new FormData();
    formData.append('file', this.excelFile);
    examCreateModule.loadStudents(formData).then(response => {
      this.isRunning = false;
    });
  }

  handleCleanStudents() {
    examCreateModule.setExamineeStudents([]);
  }

  get targetSelectedStudentCount(): number {
    if (examCreateModule.evalSettingModeEdit) {
      return examCreateModule.plusExamineeStudents.length;
    } else {
      return examCreateModule.assignedExamineeStudents.length;
    }
  }

  get examineeStudents(): Student[] {
    return examCreateModule.examineeStudents;
  }

  get evalSettingModeEdit(): boolean {
    return examCreateModule.evalSettingModeEdit;
  }
}
